import { TaskTrackerGanttChart } from "./gantt-chart";
import { TaskTrackerDataTable } from "./data-table";
import { FormatDate } from "../../../shared/scripts/date-functions";
import { Task } from "./task-tracker.entities";
import { plainToClass } from "class-transformer";


export class TaskTrackerPage {

    tasks: Task[];
    ganttChart: TaskTrackerGanttChart;
    dataTable: TaskTrackerDataTable;

    constructor(title: string, taskJson: any, lastUpdate: string, showGanttTab: boolean, showMilestoneTaskFilter: boolean, showCriticalTaskFilter: boolean, showStudyFilter: boolean) {

        $(() => {
            //console.log("Task Tracker", title, lastUpdate, taskJson);
            //console.log(showMilestoneTaskFilter, showCriticalTaskFilter, showStudyFilter);
            //console.log(Boolean(showMilestoneTaskFilter), Boolean(showStudyFilter));

            $('#page-title').text(title);
            $('#last-update-date').text(lastUpdate);

            this.tasks = plainToClass(Task, <Task[]>taskJson);
            this.tasks.forEach((t: Task) => {
                t.Initialize();
            })

            //console.log(this.tasks);

            if (showGanttTab) {
                this.ganttChart = new TaskTrackerGanttChart();
                this.ganttChart.initialize(this.tasks, showStudyFilter);
            }

            this.dataTable = new TaskTrackerDataTable(this.tasks, showMilestoneTaskFilter, showCriticalTaskFilter, showStudyFilter);

            this.setupTabWatcher();
        });
    }

    setupTabWatcher(): void {
        $('a[data-toggle="pill"]').on('shown.bs.tab', (e) => {
            if (e.currentTarget.id == "content-datatable-tab") {
                this.dataTable.refresh();
            }
            else if (e.currentTarget.id == "content-gantt-tab") {
                //this.map.refresh();
                //console.log("gantt tab");
            }
        });
    }

}